// URGENT privacy fix: strip first_name/last_name/email/phone_number/mobile
// from the URL before anything else runs (kept in sessionStorage only)
import './utils/stripOnLoad'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './styles/t2d.css'

Vue.config.productionTip = false

// Capture UTMs / click IDs from the landing URL before any navigation
import { captureAttribution } from './utils/attribution'
captureAttribution({ search: window.location.search })

// Landing URL for HubSpot's source tracking (the steps can drop the query string)
import { captureLandingUrl } from './utils/hubspotTracking'
captureLandingUrl(window.location.href)

// Ad data consent: HubSpot banner listener (UK subdomain) / ttd_adc link param
import { initAdConsent } from './utils/adConsent'
initAdConsent({ search: window.location.search })

import axios from 'axios'
import './registerServiceWorker'
Vue.prototype.$axios = axios

var api = {
  servers: {
    backend: process.env.VUE_APP_URL_API_BACKEND,
  },
  fetch: async(props) => {
    var params = {}
    var headers = {}
    var method = 'post'
    if (typeof props.params != 'undefined') params = props.params
    if (typeof props.method != 'undefined') method = props.method
    if (typeof props.headers != 'undefined') headers = props.headers
    props.callbackReset();
    try {
      await axios({
          method: method,
          headers: headers,
          url: props.url,
          data: params,
        })
        .then(
          (response) => {
            if (response.data == null) {
              props.callbackError('Item not found.');
            } else if (response.data.error) {
              props.callbackError(response.data.error);
            } else {
              props.callbackSuccess(response.data);
            }
          },
          (error) => {
            if (typeof error.response != 'undefined' && typeof error.response.data != 'undefined') {
              var err;
              if (typeof error.response.data.errors != 'undefined' && error.response.data.errors) {
                //read Laravel ValidationException errors message
                var errors = error.response.data.errors;
                err = errors[Object.keys(errors)[0]];
              } else if (typeof error.response.data.message != 'undefined') {
                err = error.response.data.message;
              } else {
                err = error;
              }
              props.callbackError(err);
            } else {
              props.callbackError(error);
            }
          }
        );
    } catch (e) {
      props.callbackError(e);
    }
  },
}

Vue.component('AError', require('./components/AError.vue').default);

Vue.prototype.$api = api

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
